"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Content = exports.Container = exports.Actions = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _info = _interopRequireDefault(require("./info.style"));

var _warning = _interopRequireDefault(require("./warning.style"));

var _error = _interopRequireDefault(require("./error.style"));

var _success = _interopRequireDefault(require("./success.style")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__Container",
  componentId: "sc-1m3t355-0"
})(["padding:", " ", " ", " 3rem;background-repeat:no-repeat;background-size:20px;background-position:14px 18px;border-left:", " solid;", ""], function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.tokens.spacing05;
}, function (p) {
  return p.theme.tokens.spacing02;
}, function (p) {
  switch (p.variant) {
    case 'info':
      return (0, _info["default"])(p);

    case 'warning':
      return (0, _warning["default"])(p);

    case 'error':
      return (0, _error["default"])(p);

    case 'success':
      return (0, _success["default"])(p);

    default:
      return (0, _info["default"])(p);
  }
});

exports.Container = Container;

var Title = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "indexstyles__Title",
  componentId: "sc-1m3t355-1"
})(["font-weight:", ";margin:0;"], function (p) {
  return p.theme.tokens.fontWeightBold;
});

exports.Title = Title;

var Content = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "indexstyles__Content",
  componentId: "sc-1m3t355-2"
})(["margin:0;"]);

exports.Content = Content;

var Actions = /*#__PURE__*/_styledComponents["default"].p.withConfig({
  displayName: "indexstyles__Actions",
  componentId: "sc-1m3t355-3"
})(["margin:", " 0 0 0;button,a{margin-right:", ";}"], function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.spacing06;
});

exports.Actions = Actions;